import {Component, Input, OnInit, OnChanges, SimpleChanges} from '@angular/core';
import { StateService } from '@uirouter/core';
import { PagedResponse, SessionService, User } from '@edl-development/edl-common';
import { EdlItemPacketUserSummaryDTO } from '../model/item-packet/edl-item-packet-user-summary-dto.model';
import { UserSummary } from '../model/user-summary.model';

@Component({
    selector: 'edl-my-compliance-items',
    templateUrl: './my-compliance-items.component.html',
    styleUrls:   [
        './my-compliance-items.component.scss',
        '../supervision-management/compliance-items/compliance-items.scss'
    ]
})
export class MyComplianceItemsComponent implements OnInit, OnChanges {
    @Input() pagedResponse: PagedResponse<UserSummary>;
    @Input() currentPage: number;
    @Input() user: User;
    @Input() isMyItems: boolean;
    @Input() itemPackets: EdlItemPacketUserSummaryDTO[] = [];

    isLoading: boolean = false;
    archived:string;
    get isUser(): boolean {
        return this.sessionService.user?.UserID === this.user?.UserID;
    }

    constructor(
        private stateService: StateService,
        private sessionService: SessionService
    ) {
        this.currentPage = 1;
    }

    ngOnInit() {
        let params = this.stateService.params;
        this.archived = params.archived;
    }

    ngOnChanges(changes: SimpleChanges) {
        // When pagedResponse changes (new data arrived), turn off loading
        if (changes['pagedResponse'] && !changes['pagedResponse'].firstChange) {
            this.isLoading = false;
        }
    }

    onPageChange(page: number) {
        const currentStatePage = Number(this.stateService.params['page']);

        // Only show loading if we're actually navigating to a different page
        if (page !== currentStatePage) {
            this.isLoading = true;
        }

        this.stateService
            .go(this.stateService.current.name, {
                page: page
            });
    }

    daysRemaining(summaryItem: any) {
        let endDate: any = new Date(summaryItem.EndDate);
        let startDate: any = new Date();

        let diff = Math.round((endDate - startDate) / (1000*60*60*24));

        return diff;
    }
}